import useMediaQuery from '@mui/material/useMediaQuery';
import { VIEWPORT } from 'src/constants/theme/viewport';

export const useIsTablet = (): boolean => {
  const isTablet = useMediaQuery(`(max-width: ${VIEWPORT.tablet})`);
  return isTablet;
};
